"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBBadgeBase = _interopRequireDefault(require("./HBBadgeBase"));
var _excluded = ["size", "type"];
var TYPE = {
  accent: {
    backgroundColor: _colors["default"].rebelYellow,
    color: _colors["default"].neutral900
  },
  neutral: {
    backgroundColor: _colors["default"].neutral200,
    color: _colors["default"].neutral800
  }
};
var HBBadgeNew = function HBBadgeNew(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'accent' : _ref$type,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_HBBadgeBase["default"], (0, _extends2["default"])({
    size: size,
    bg: TYPE[type].backgroundColor,
    color: TYPE[type].color
  }, props));
};
var _default = exports["default"] = HBBadgeNew;
//# sourceMappingURL=HBBadgeNew.js.map